module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-th.e36a1823.png";